<template>
    <div class="editProfile mainContent">
        <Documents />
    </div>
</template>

<script>
    import Documents from '../../components/sidebar/Documents';

    export default {
        components: {
            Documents,
        }
    }
</script>